module.exports = __webpack_public_path__ + "img/content-01_2x.4e6ace3f.png";